import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import { useNavigate } from "react-router-dom";
import { Grid, Paper, Box, Alert, Button } from "@mui/material";
import { useUser } from '../../context/UserContext';
import { forgotPassword } from '../../api/authService';


export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const {updateUser} = useUser();
  const [userEmail, setUserEmail] = useState("");
  

  const handleChange = (e) => {
    setUserEmail(e.target.value);
    setError(""); // Clear previous error message
    const { name, value } = e.target;
    setEmail(e.target.value);
    updateUser(name, value); // Dynamically update the field
  };
  const handleCancel = () => {
    setUserEmail(""); // Clear the email field
    setError(""); // Clear the error message
    navigate('/');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    //alert("Password reset link has been sent to your email.");

    try {
     
     const { response} = await forgotPassword( email );

      if (response.ok) {
        setSuccess("Email sent successfully!");
        navigate("/ValidateOTP"); // Route to ValidateOTP
      } else {
        const data = await response.json();        
        setError(data.message );
      }
    } catch (err) {
      setError("An error occurred. Please try again.");
    }
  };

  return (
    <>
    <Box
      minHeight="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      bgcolor="#f9f9f9"
    >
    <div style={{ padding: "20px" }}>
      <h2>Reset Your Password</h2>
      <h4>
        Enter the email address associated with your account and we'll send you
        an OTP to reset your password.
      </h4>

      <form onSubmit={handleSubmit}>
        <Grid item xs={12} sm={6}>
          <Paper elevation={3} style={{ padding: '16px' }}>
            <TextField
              type="email"
              required
              fullWidth
              variant="outlined"
              id="email"
              label="Email"
              name="email"
              value={userEmail}
              onChange={handleChange}
            />
          </Paper>
        </Grid>
        

        <br />

        <div>
          <br />
        </div>
            <Grid container spacing={2} justifyContent="center" >
              <Grid item>
                <Button variant="contained" color="primary" onClick={handleCancel} sx={{ mr: 4 }}>
                  Cancel
                </Button>
              </Grid>
              <Grid item>
                <Button type="submit" variant="contained" color="primary" >
                  Email Me the OTP
                </Button>
              </Grid>
            </Grid>
            {error && (
              <Grid item xs={12}>
                <Alert severity="error">{error}</Alert>
              </Grid>
            )}
            {success && (
              <Grid item xs={12} style={{ marginTop: '16px' }}>
                <Alert severity="success">{success}</Alert>
              </Grid>
            )}

        
      </form>
    </div>
    </Box>
    </>
  );
}
